import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import MemberCpt from '@/components/member';
import { requestApi } from '@/api/config';
import { createUuid } from '@/asset/js/util';
import { withTranslation } from 'react-i18next';
import './index.less';

class Member extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      pageNo: 1,
      pageSize: 12,
      totalPage: 10,
      totals: '',
    };
  }

  componentDidMount() {
    this.getData();
    const { pageNo, pageSize } = this.state;
    // eslint-disable-next-line no-console
    console.log(pageNo, pageSize);
  }

  getData() {
    const { pageNo } = this.state;
    requestApi('MEMBER_LIST', { page: pageNo })
      .then((res) => {
        this.setState({
          list: res.data,
          pageNo: res.current_page,
          totals: res.total,
          totalPage: res.last_page,
        });
      })
      .catch(() => {});
  }

  handlePageClick(data) {
    const pageIndex = data.selected;
    this.setState({ pageNo: pageIndex + 1 }, () => {
      this.getData();
    });
  }

  _renderSearch() {
    const { totals } = this.state;
    const { t } = this.props;
    console.log('totals :>> ', totals);
    return (
      <div className='block-container home-works-container'>
        <div className='container'>
          <div className='row'>
            <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'>
              <div className='search-wrapper'>
                <p className='count'>
                  {/* className="num" */}
                  {t('common.membersTotal', { total: totals })}
                </p>
                <div className='search-content'>{/* Search */}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _renderList() {
    const { list, totalPage } = this.state;
    return (
      <div className='block-container home-works-container'>
        <div className='container'>
          <div className='row member-wrapper'>
            {list.map((item) => (
              <div
                className='col-xs-4 col-sm-4 col-md-2 col-lg-2'
                key={createUuid()}
              >
                <MemberCpt data={item} />
              </div>
            ))}
          </div>
          <div className='row'>
            <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'>
              <div className='paginate-wrapper'>
                <ReactPaginate
                  onPageChange={this.handlePageClick.bind(this)}
                  pageCount={totalPage}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  previousLabel={'<'}
                  nextLabel='>'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const searchDom = this._renderSearch();
    const listDom = this._renderList();
    return (
      <div className='white-container works-list-container'>
        {searchDom}
        {listDom}
      </div>
    );
  }
}

export default withTranslation('translation', { withRef: true })(Member);
